import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { animated, config, useSpring } from 'react-spring';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { BodyM } from '@sorare/core/src/atoms/typography';
import {
  ResponsiveImg,
  ValidWidths,
} from '@sorare/core/src/atoms/ui/ResponsiveImg';

import { positionShortNames } from '@sorare/gameplay/src/lib/so5';

import { DraftPositionType } from 'components/rivals/draft/lib';

const TooltipStyled = styled(Tooltip)`
  width: 100%;
  height: 100%;
`;
const StyledAnimatedResponsiveImg = styled(animated(ResponsiveImg))`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

type ImgProps = React.PropsWithChildren<{
  src: string;
  alt: string;
  width: ValidWidths;
  height: number;
}>;
const Img = ({ width, ...rest }: ImgProps) => {
  const animation = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: config.gentle,
    delay: 150,
  });
  return (
    <StyledAnimatedResponsiveImg
      style={animation}
      {...rest}
      cropWidth={width}
    />
  );
};

type Props = {
  position: DraftPositionType;
  draftablePlayer: Nullable<{
    avatarUrl?: Nullable<string>;
    player: { displayName: string };
  }>;
};
export const PickerSlotContent = ({ position, draftablePlayer }: Props) => {
  if (draftablePlayer) {
    const { avatarUrl, player } = draftablePlayer;
    return (
      <TooltipStyled title={player.displayName}>
        <Img
          src={avatarUrl || ''}
          alt={player.displayName}
          width={80}
          height={80}
        />
      </TooltipStyled>
    );
  }
  return (
    <>
      <FontAwesomeIcon icon={faUserPlus} size="lg" />
      <BodyM>
        <strong>
          <FormattedMessage {...positionShortNames[position]} />
        </strong>
      </BodyM>
    </>
  );
};
